export default __webpack_public_path__ + "static/media/logo.b3c6aac4.png";